import { useState } from 'react'
import useAuthHook from '../userAuth'
import Button from '../components/Button'
import InputField from '../components/InputField'

import logo from '../assets/logo.png'

const LoginPage = () => {
  const { loginWithGoogle, sendEmailLink, authError, setAuthError } = useAuthHook()
  const [email, setEmail] = useState('')
  const [emailLinkSent, setEmailLinkSent] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleEmailLink = async (e) => {
    e.preventDefault()
    if (!email.trim()) return
    setIsSubmitting(true)
    const success = await sendEmailLink(email.trim())
    if (success) setEmailLinkSent(true)
    setIsSubmitting(false)
  }

  return (
    <div className='min-h-screen bg-gray-100 flex items-center justify-center'>
      <div className='bg-white rounded-lg shadow-lg p-8 w-full max-w-md'>
        <div className='flex flex-col items-center mb-6'>
          <img alt='logo' className='h-12 mb-3' src={logo} />
          <h1 className='text-2xl font-bold text-blue-10'>IHT Self-Service</h1>
        </div>

        {authError && (
          <div className='bg-red-50 text-red-600 text-sm p-3 rounded mb-4'>
            {authError}
          </div>
        )}

        {emailLinkSent
          ? (
            <div className='text-center'>
              <p className='text-green-600 mb-4'>Sign-in link sent. Check your inbox.</p>
              <button
                type='button'
                className='text-blue-6 hover:underline text-sm'
                onClick={() => { setEmailLinkSent(false); setAuthError() }}
              >
                Try again
              </button>
            </div>
            )
          : (
            <form onSubmit={handleEmailLink}>
              <p className='text-sm text-gray-600 mb-3'>
                Enter your email and we'll send you a link to sign in — no password needed.
              </p>
              <InputField
                labelFor='email'
                type='email'
                id='loginEmail'
                name='email'
                placeholder='you@example.com'
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              >
                Email
              </InputField>
              <Button type='submit' className='w-full' disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Sign-In Link'}
              </Button>
              <div className='mt-4 border-t pt-4'>
                <button
                  type='button'
                  className='w-full flex items-center justify-center gap-2 border border-gray-300 rounded p-2 hover:bg-gray-50 text-sm'
                  onClick={loginWithGoogle}
                >
                  <svg className='w-5 h-5' viewBox='0 0 24 24'>
                    <path fill='#4285F4' d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z' />
                    <path fill='#34A853' d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z' />
                    <path fill='#FBBC05' d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z' />
                    <path fill='#EA4335' d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z' />
                  </svg>
                  Sign in with Google
                </button>
              </div>
            </form>
            )}
      </div>
    </div>
  )
}

export default LoginPage
